import * as React from "react";
import { TransformComponent } from "react-zoom-pan-pinch";
import { useIntersectionObserver } from "@grandvisionhq/lib-utils-react";
const ZoomModalImage = ({ image, handleInView, isSmallScreen, index }) => {
  const { ref } = useIntersectionObserver({
    threshold: 0.8,
    onChange: (inView) => handleInView(inView, index)
  });
  return isSmallScreen ? /* @__PURE__ */ React.createElement(TransformComponent, { wrapperClass: "zoom-modal__zoom-wrapper" }, /* @__PURE__ */ React.createElement(
    "picture",
    {
      ref,
      "data-index": index,
      id: `zoom-modal__image-slide-${index}`,
      className: "zoom-modal__picture"
    },
    /* @__PURE__ */ React.createElement(
      "img",
      {
        src: image.url,
        className: "zoom-modal__image",
        srcSet: image.srcSet,
        sizes: image.sizes,
        alt: image.altText
      }
    )
  )) : /* @__PURE__ */ React.createElement(
    "picture",
    {
      ref,
      "data-index": index,
      id: `zoom-modal__image-slide-${index}`,
      className: "zoom-modal__picture"
    },
    /* @__PURE__ */ React.createElement(
      "img",
      {
        src: image.url,
        className: "zoom-modal__image",
        srcSet: image.srcSet,
        sizes: image.sizes,
        alt: image.altText
      }
    )
  );
};
export {
  ZoomModalImage
};
//# sourceMappingURL=ZoomModalImage.js.map
